import {
  Attribute,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ErrorHandler,
  HostBinding,
  Inject,
  Input,
} from '@angular/core';
import { MAT_ICON_LOCATION, MatIcon, MatIconLocation, MatIconRegistry } from '@angular/material/icon';

@Component({
  selector: 'icon',
  standalone: true,
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    role: 'img',
    '[class.si]': 'true',
  },
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent extends MatIcon {
  @Input()
  @HostBinding('class.rotate-90')
  public rotate = false;

  @Input()
  @HostBinding('class.si--animated')
  public animated = false;

  public constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    private iconRegistry: MatIconRegistry,
    @Attribute('aria-hidden') ariaHidden: string,
    @Inject(MAT_ICON_LOCATION) private location: MatIconLocation,
    private readonly errorHandler: ErrorHandler,
  ) {
    super(elementRef, iconRegistry, ariaHidden, location, errorHandler);
  }
}
